import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

const GoTop = () => {
    const handleClick = () => {
        window.scroll({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className={styles.goTop} onClick={handleClick} />
    );
};

export default errorBoundary(React.memo(GoTop));
